import React from "react";

export default function Impressum() {
	return (
		<div className="impressum_page">
			<div className="impressum_block">
				<h1>Impressum</h1>
				<br />
				<div className="contact-info">
					<p className="contact-info__company">Feingeist GmbH</p>
					<ul className="contact-info">
						<li>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="20"
								height="20"
								fill="black"
								className="bi bi-telephone"
								viewBox="0 0 16 16"
							>
								<path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
							</svg>
							<span>+49 (0) 30 700 127 060</span>
						</li>
						<li>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="20"
								height="20"
								fill="black"
								className="bi bi-envelope"
								viewBox="0 0 16 16"
							>
								<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
							</svg>
							<span>info@feingeist-beratung.de</span>
						</li>
					</ul>
					<ul className="contact-info__links"></ul>
					<div className="contact-info__address">
						<p>
							Feingeist GmbH
							<br />
							Quartier Potsdamer Platz
							<br />
							Linkstraße 2 | Level 8<br />
							10785 Berlin
						</p>
					</div>
				</div>
				<br />
				<p>
					<strong>Vertreten durch:</strong>
					<br />
					Gregor Kretschmann, Kristin Aßmann
				</p>
				<p>
					<strong>
						Umsatzsteuer-Identifikationsnummer gem. § 27 a Umsatzsteuergesetz:
					</strong>
					<br /> DE292969278
					<br />
					<strong>Handelsregister:</strong>
					<br />
					Amtsgericht Charlottenburg (Berlin)
					<br />
					<strong>Handelsregisternr:</strong>
					<br />
					HRB 155911 B<br />
					<strong>
						Verantwortlich für den Inhalt der Seiten im Sinne des § 5 TMG und
						des § 55 II RStV:
					</strong>
					<br /> Gregor Kretschmann
					<br />
				</p>
				<h2>Bildrechte</h2>
				<ul className="typeset-u-list">
					<li className=" py-3">
						<div className="impressum-pt">
							<em>Business</em> — Piktogram von
							<a
								className="description-link"
								href="https://thenounproject.com/christian933/"
							>
								Made x Made
							</a>
							aus
							<a
								className="description-link"
								href="https://thenounproject.com/"
							>
								the Noun Project
							</a>
							(Startseite)
						</div>
					</li>
					<li className=" py-3">
						<div className="impressum-pt">
							<em>Buildungs</em> — Piktogram von
							<a
								className="description-link"
								href="https://thenounproject.com/christian933/"
							>
								Made x Made
							</a>
							aus
							<a
								className="description-link"
								href="https://thenounproject.com/"
							>
								the Noun Project
							</a>
							(Startseite)
						</div>
					</li>
					<li className=" py-3">
						<div className="impressum-pt">
							<span>
								<em>Man writing on paper</em> — Foto von
								<a
									className="description-link"
									href="https://unsplash.com/@sctgrhm?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText"
								>
									Scott Graham
								</a>
								aus
								<a
									className="description-link"
									href="https://unsplash.com/s/photos/business-contract?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText"
								>
									Unsplash
								</a>
							</span>
							(Startseite)
						</div>
					</li>
					<li className=" py-3">
						<div className="impressum-pt">
							<span>
								<em>Metal gears</em> — Foto von
								<a
									className="description-link"
									href="https://unsplash.com/@bill_oxford?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText"
								>
									Bill Oxford
								</a>
								aus
								<a
									className="description-link"
									href="https://unsplash.com/@bill_oxford?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText"
								>
									Unsplash
								</a>
							</span>
							(Startseite)
						</div>
					</li>
					<li className=" py-3">
						<div className="impressum-pt">
							<em>Calculator and Pen on Table</em> — Foto von
							<a
								className="description-link"
								href="https://www.pexels.com/@pixabay"
							>
								Pixabay
							</a>
							aus
							<a className="description-link" href="https://www.pexels.com">
								Pexels
							</a>
							(Startseite)
						</div>
					</li>
				</ul>
				<h2>Datenschutzerklärung</h2>
				<p>Allgemeiner Hinweis und Pflichtinformationen</p>
				<h3 className="impressum_hd">Benennung der verantwortlichen Stelle</h3>
				<p>
					Die verantwortliche Stelle für die Datenverarbeitung auf dieser
					Website ist:
				</p>
				<p>
					Feingeist GmbH Quartier Potsdamer Platz Linkstraße 2 | Level 8 10785
					Berlin
				</p>
				<p>
					Die verantwortliche Stelle entscheidet allein oder gemeinsam mit
					anderen über die Zwecke und Mittel der Verarbeitung von
					personenbezogenen Daten (z.B. Namen, Kontaktdaten o. Ä.). Widerruf
					Ihrer Einwilligung zur Datenverarbeitung
				</p>
				<p>
					Nur mit Ihrer ausdrücklichen Einwilligung sind einige Vorgänge der
					Datenverarbeitung möglich. Ein Widerruf Ihrer bereits erteilten
					Einwilligung ist jederzeit möglich. Für den Widerruf genügt eine
					formlose Mitteilung per E-Mail. Die Rechtmäßigkeit der bis zum
					Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
					Recht auf Beschwerde bei der zuständigen Aufsichtsbehörde
				</p>
				<p>
					Als Betroffener steht Ihnen im Falle eines datenschutzrechtlichen
					Verstoßes ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
					Zuständige Aufsichtsbehörde bezüglich datenschutzrechtlicher Fragen
					ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem sich der
					Sitz unseres Unternehmens befindet. Der folgende Link stellt eine
					Liste der Datenschutzbeauftragten sowie deren Kontaktdaten bereit:
					<a
						className="description-link"
						href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html"
					>
						Anschriften_Links
					</a>
					Recht auf Datenübertragbarkeit
				</p>
				<p>
					Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer
					Einwilligung oder in Erfüllung eines Vertrags automatisiert
					verarbeiten, an sich oder an Dritte aushändigen zu lassen. Die
					Bereitstellung erfolgt in einem maschinenlesbaren Format. Sofern Sie
					die direkte Übertragung der Daten an einen anderen Verantwortlichen
					verlangen, erfolgt dies nur, soweit es technisch machbar ist. Recht
					auf Auskunft, Berichtigung, Sperrung, Löschung
				</p>
				<p>
					Sie haben jederzeit im Rahmen der geltenden gesetzlichen Bestimmungen
					das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
					personenbezogenen Daten, Herkunft der Daten, deren Empfänger und den
					Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung,
					Sperrung oder Löschung dieser Daten. Diesbezüglich und auch zu
					weiteren Fragen zum Thema personenbezogene Daten können Sie sich
					jederzeit über die im Impressum aufgeführten Kontaktmöglichkeiten an
					uns wenden.
				</p>
				<h3 className="impressum_hd">SSL- bzw. TLS-Verschlüsselung</h3>
				<p>
					Aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher
					Inhalte, die Sie an uns als Seitenbetreiber senden, nutzt unsere
					Website eine SSL-bzw. TLS-Verschlüsselung. Damit sind Daten, die Sie
					über diese Website übermitteln, für Dritte nicht mitlesbar. Sie
					erkennen eine verschlüsselte Verbindung an der „https://“ Adresszeile
					Ihres Browsers und am Schloss-Symbol in der Browserzeile.
				</p>
				<h3 className="impressum_hd">Kontaktformular</h3>
				<p>
					Per Kontaktformular übermittelte Daten werden einschließlich Ihrer
					Kontaktdaten gespeichert, um Ihre Anfrage bearbeiten zu können oder um
					für Anschlussfragen bereitzustehen. Eine Weitergabe dieser Daten
					findet ohne Ihre Einwilligung nicht statt.
				</p>
				<p>
					Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt
					ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a
					DSGVO). Ein Widerruf Ihrer bereits erteilten Einwilligung ist
					jederzeit möglich. Für den Widerruf genügt eine formlose Mitteilung
					per E-Mail. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
					Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.
				</p>
				<p>
					Über das Kontaktformular übermittelte Daten verbleiben bei uns, bis
					Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung
					widerrufen oder keine Notwendigkeit der Datenspeicherung mehr besteht.
					Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen
					– bleiben unberührt.
				</p>
			</div>
		</div>
	);
}
